import Parser from "html-react-parser";
import { useHeaderScripts } from "../utils/useHeaderScripts";

type HeaderProps = {
  dataHtml: string;
  headerScript: HTMLScriptElement[];
  cssReady: boolean;
};

function Header({ dataHtml, headerScript, cssReady }: HeaderProps) {
  const scriptsReady = useHeaderScripts(headerScript);

  // Hold off on painting the real markup/icons until css is bound and scripts have run
  if (!cssReady || !scriptsReady || !dataHtml) {
    return <div></div>;
  }

  try {
    return <>{Parser(dataHtml || "")}</>;
  } catch (error) {
    console.error("Header render error:", error);
    return <></>;
  }
}
export default Header;
